import PropTypes from 'prop-types';
import { memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import DropdownSelectFilter from '../../../../Filters/DropdownSelectFilter';
import {
  StopFilterOptions,
} from '../../../../../constants';
import { flightSearch, updateFlightSearchObj } from '../../../../../store/slices/flight';
import flightSearchInput from '../../../../../helpers/selectors/flightSearchInput';
import { setFlightTripSearchInputs } from '../../../../../store/slices/tripSearch';

const FlightStops = ({
  tripId, isFilter, variant, filterSpacingClass, filterBgColor,
}) => {
  const propertyName = isFilter ? 'filterStops' : 'maxNumOfStops';
  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const isTripSearch = !tripId;
  const {
    searchInputs, defaultSearchObj, airlinesAutocompleteResults,
  } = useSelector(flightSearchInput(tripId, isTripSearch));

  if (isFilter && (!airlinesAutocompleteResults
     || !airlinesAutocompleteResults.length)) { return <></>; }

  const handleChange = (newValue) => {
    const payload = {
      tripId,
      searchObj: {
        [propertyName]: newValue,
        page: 1,
      },
    };

    if (isTripSearch) {
      dispatch(setFlightTripSearchInputs({ ...payload.searchObj }));
      if (isFilter) dispatch(flightSearch({ isTripSearch: true, ...payload.searchObj }));
    } else if (isFilter) dispatch(flightSearch(payload));
    else dispatch(updateFlightSearchObj(payload));
    track('stopsFlightFilter.handleChange', {
      [propertyName]: newValue,
    });
  };
  const dropdownLabel = isFilter ? 'Filter by stops' : 'Stops Preference';
  return (
    <DropdownSelectFilter
      label={dropdownLabel}
      tooltipPrependText={dropdownLabel}
      onChange={handleChange}
      options={StopFilterOptions}
      defaultOptionValue={defaultSearchObj[propertyName]}
      selectedOptionValue={searchInputs[propertyName]}
      menuWidth="w-64"
      filterButtonMaxWidth="max-w-full"
      variant={variant}
      filterSpacingClass={filterSpacingClass}
      bgClassName={!isTripSearch ? '' : filterBgColor}
    />
  );
};

FlightStops.propTypes = {
  tripId: PropTypes.string,
  isFilter: PropTypes.bool,
  variant: PropTypes.string,
  filterSpacingClass: PropTypes.string,
  filterBgColor: PropTypes.string,
};

FlightStops.defaultProps = {
  tripId: undefined,
  isFilter: false,
  variant: undefined,
  filterSpacingClass: undefined,
  filterBgColor: undefined,
};

export default memo(FlightStops);
